import { render, staticRenderFns } from "./BloqueSigueme.vue?vue&type=template&id=1024c1c4&scoped=true"
import script from "./BloqueSigueme.vue?vue&type=script&lang=js"
export * from "./BloqueSigueme.vue?vue&type=script&lang=js"
import style0 from "./BloqueSigueme.vue?vue&type=style&index=0&id=1024c1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024c1c4",
  null
  
)

export default component.exports